import { ArrowUDownRightBoldIcon } from './ArrowUDownRightBoldIcon';

/**
 * author: Colton Wiscombe
 * id 0B6ECB18-2663-4365-BBD1-3FE6A0A2A45C
 * name arrow-u-down-right-bold
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-u-down-right-bold.svg
 * tags
 */
export const UTurnRightBoldIcon = ArrowUDownRightBoldIcon;
export default UTurnRightBoldIcon